import React, { FC } from 'react';
import styled, { css } from 'styled-components';

interface Props {
   label?: string,
   error?: boolean,
   title?: string,
   styles?: FormFieldLabelStyles,
   clickHandler?(e: any): void
}

export interface FormFieldLabelStyles {
   fontSize?: string,
   fontWeight?: string,
   color?: string,
   marginLeft?: string,
   marginTop?: string
}

const FormFieldLabel: FC<Props> = (props) => {

   const { error, label, title, clickHandler  } = props;

   return (
      <BaseFieldHeading onClick={clickHandler} error={error} {...props}>{title && <Title>{title}</Title>}{label}</BaseFieldHeading>
   );
}

const BaseFieldHeading = styled.h5`
  color: ${(inputProps: Props) => inputProps.error ? css` 
   ${props => (props.theme.colors ? props.theme.colors.error : 'red')}; 
  ` : inputProps.styles && inputProps.styles.color ? inputProps.styles.color : '#9EA8AB'};
  font-family: ${props => (props.theme.font ? props.theme.font.primary : 'inherit')}; 
  font-size: ${props => props.styles && props.styles.fontSize ? props.styles.fontSize : '16px' };
  margin-block-end: 0.5em;
  text-transform: capitalize;
  font-weight: ${props => props.styles && props.styles.fontWeight ? props.styles.fontWeight : '300' };
  margin-left: ${props => props.styles && props.styles.marginLeft ? props.styles.marginLeft : '' };
  margin-top: ${props => props.styles && props.styles.marginTop ? props.styles.marginTop : '' };
  cursor: pointer;
`;

const Title = styled.span`
   font-family: ${props => (props.theme.font ? props.theme.font.bold : 'inherit')};
   color: #8E9A9D;
   margin-right:10px;
`;

export default FormFieldLabel;